module.exports = __webpack_public_path__ + "img/icon-valid-doc.71dc966c.svg";